import React from 'react';
import { EntityAskAI } from '../common/EntityAskAI';

interface CompanyAskAIProps {
  companyName: string;
  fileIds: string[];
  teamId: string;
}

const getSuggestions = (companyName: string) => [
  `What was discussed about ${companyName}?`,
  `What are the main topics related to ${companyName}?`,
  `What problems were mentioned about ${companyName}?`,
  `What are the key points regarding ${companyName}?`,
  `Create a summary report about ${companyName}`,
];

export const CompanyAskAI: React.FC<CompanyAskAIProps> = ({
  companyName,
  fileIds,
  teamId,
}) => {
  return (
    <EntityAskAI
      entityName={companyName}
      entityType="company"
      fileIds={fileIds}
      teamId={teamId}
      getSuggestions={getSuggestions}
    />
  );
};

export default CompanyAskAI;
